/*
 * @Author: Q in 
 * @Date: 2026-05-27 14:19:24
 * @LastEditors: Q in 
 * @LastEditTime: 2026-08-05 17:40:43
 * @FilePath: /new_kefu_pc/src/utils/config.js
 * @Description: 公共配置文件
 */

// ==================== 所有环境公用配置 ====================
const commonConfig = {
	// AES 加密密钥（16位）
	aesKey: 'gbcdeg0922456789',
	// OSS 地域节点
	region: 'oss-cn-beijing',
	// OSS AccessKeyId（勿硬编码）
	accessKeyId: '',
    // accessKeyId: 'dXS6wqlVo3CYo0j5oMIniPeYI4YEzTT2LbM8q/hxKKU=',
	// OSS AccessKeySecret（勿硬编码）
	accessKeySecret: '',
    // accessKeySecret: 'bxxJbw2d5AbvYBHnbVo96Ljic8iq3gPu2vUIPDw/aIE=',
	// OSS Bucket 名称
	bucket: 'xianyouhe',
	// OSS 原始上传地址
	aliyunImageUrl: 'https://xianyouhe.oss-cn-beijing.aliyuncs.com',
	// 图片 CDN 加速域名
	imageUrl: 'https://images.xianyouhe.com',
	// 分站图片裁剪参数
	substationImageParams: '?x-oss-process=image/crop,x_0,y_0,h_800,g_north',
};

// ==================== 测试环境专用配置 ====================
const testEnvConfig = {
	baseApiDomain: 'https://apicode.xianyouhe.com',
	wssApiDomain: 'wss://apicode.xianyouhe.com:1818',
};

// ==================== 正式环境专用配置 ====================
const prodEnvConfig = {
	baseApiDomain: 'https://kefu.xianyouhe.com/index.php',
	wssApiDomain: 'wss://kefu.xianyouhe.com:1818',
};

// 合并最终配置并导出（修改下方注释行即可切换环境）
const config = {
	...commonConfig,
	...testEnvConfig, // 测试环境
	...prodEnvConfig, // 正式环境
};

module.exports = config;
